import React from 'react';
import PropTypes from 'prop-types';
import { SegmentedControl, SegmentedControlItem } from 'web-ui-components/lib/molecules/forms';
import { managePaymentFilterOptions } from '../../../config';

const ManagePaymentsFilterOptions = ({ selectedFilter, handleManagePaymentFilterChange }) => (
	<SegmentedControl>
		{managePaymentFilterOptions.map((option) => (
			<SegmentedControlItem
				key={option.id}
				checked={selectedFilter === option.type}
				onClick={() => {
					handleManagePaymentFilterChange(option.type);
				}}
				id={`segmented-control-id-${option.id}`}
			>
				{option.type}
			</SegmentedControlItem>
		))}
	</SegmentedControl>
);

ManagePaymentsFilterOptions.propTypes = {
	selectedFilter: PropTypes.string.isRequired,
	handleManagePaymentFilterChange: PropTypes.func.isRequired,
};

export default ManagePaymentsFilterOptions;
